import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IDynamicElement } from '../../_shared/models/dynamic/dynamic-element.model';
import { ITableSet } from '../../_shared/models/table/table-set.model';
import { ITable } from '../../_shared/models/table/table.model';
import { GridComponent } from '../../grid/grid.component';
import { TableComponent } from '../table.component';

import { HeadingComponent } from '../../heading/heading.component';

@Component({
    selector: 'sirius-table-group',
    templateUrl: './table-group.component.html',
    styleUrls: ['./table-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GridComponent, TableComponent, HeadingComponent]
})
export class TableGroupComponent implements OnInit, IDynamicElement {
    @Input() tables: ITable[] = [];
    @Input() title = '';
    //TODO: Rename to subtitle
    @Input() subTitle = '';

    config!: ITableSet;

    ngOnInit() {
        if (this.config) {
            this.tables = this.config.tables;
            this.title = this.config.title;
            //TODO: Rename to subtitle
            this.subTitle = this.config.subTitle;
        }
    }
}
